var hostname = window.location.hostname;
var ajout_width;
if (hostname == 'localhost') $domaine = 'http://localhost/site-pmvial2017/WP/';
else $domaine = 'https://www.pm-vial.com/';
var is_404 = false;
var array_url_autorize = [
  "",
  "expertise/",
  "agence/",
  "contact/",
  "realisations/",
  "realisation/territoire-insertion-38/",
  "realisation/la-barcarolle/",
  "realisation/enerbee/",
  "realisation/medes/",
  "realisation/college-saint-louis/",
  "realisation/creation-d-images/",
  "realisation/sweetzerland-chocolat/",
  "realisation/champvigny/",
  "realisation/signature-vegetale/",
  "realisation/atelier-cana/",
  "realisation/ad-music/",
  "realisation/nomades/",
  "realisation/treize-avril/",
  "realisation/out-of-the-box/",
  "realisation/musee-de-geneve/",
  "realisation/uldry/",
  "realisation/powernestlib/",
  "realisation/d-c-g/",
  "realisation/centre-europe-direct/",
  "realisation/docteur-viard/",
  "realisation/wiremind/",
  "realisation/level-studio/",
  "realisation/aeronautics-fund/",
  "realisation/dd-pardi/",
  "realisation/maison-du-peuple/",
  "realisation/sparks/"
];



jQuery(document).ready(function($){
	
 
	 // INIT DRAW
    var deja_init = false;
	  var transition_left_finished;
    var l_fenetre = $('#wraper_site').width();
    var h_fenetre = $(window).height();
    var midle_width = parseInt(l_fenetre/2 + 60);
    var color_svg_bord_gauche = "#ffffff";
    var $content = $("#left_pm");
    var width_svg_cadre = 65;
    var width_svg_single = 90;
    var width_left_normal = 45;
    var width_left_single = 80;
    var GLOBAL_WIDTH_SVG_CADRE = 65;
    var deplacement = l_fenetre * 0.1;  
    var $container_rea = $("#content_rea"); // content_rea contient $right_rea
    var $right_rea = $('#right_rea');
    var addClass;
    var largeur_percentage_container_rea;
    var largeur_menu_left = 76;
    var $menu_principal = $("#menu-principal");

  /* Fct pour mvt souris */
   var width_bottom = midle_width;
   var width_top = midle_width;
   var $svg_cadre = $("#svg_cadre");
   var left_de_base = 0;
   var single_rea = false;
   var full_rea_liste = false;
   var minus_svg_cadre;
   var percent;
   var diff_pourcen = 0;

   var nb_go_col_droite;
   var precedent_nb_col_droite = "init"; // ici page classique

   var corps_content_rea;
  var menu_second = document.getElementById('secon');

// TEST ENQUIRE.JS // 
var affichage_desktop = true;
enquire.register("screen and (max-width:1025px)", {
  match: function() {
    // MOBILE
    rectifitif_for_mobile();
    affichage_desktop = false;
    width_left_normal = 100;
    width_left_single = 100;
    if(deja_init)location.reload();
  },

  unmatch: function() {
    // DESKTOP
    affichage_desktop = true;
   $right_rea.css('width', $right_rea.parent().width());
   add_scroll_bar();
   rectifitif_for_desktop();
   width_left_normal = 45;
   width_left_single = 80;
   if(deja_init)location.reload();
  }
});

enquire.register("screen and (min-width: 500000px)", {
  match : function() {
      
    affichage_desktop = true;
   $right_rea.css('width', $right_rea.parent().width());
   add_scroll_bar();
   rectifitif_for_desktop();
   width_left_normal = 45;
   width_left_single = 80;
   if(deja_init)location.reload();

  }
}, true);


function rectifitif_for_desktop(){
   $container_rea.css({right:0, opacity:1});
}
function rectifitif_for_mobile(){
  $content.css({left:0});
  if (!full_rea_liste) $right_rea.css({right:"-100%"});
}


function add_scroll_bar(){
  if (affichage_desktop){
    //console.log('On ajoute le scroll');
    var el = document.querySelector('.toscrollbar'); // init scrollbar sur les reas //
    SimpleScrollbar.initEl(el);
  
    var el2 = document.querySelector('.move_on_change');
     SimpleScrollbar.initEl(el2);
    }
}
// FIN TEST ENQUIRE //

  
  // INIT
  var svg_cadre = SVG('svg_cadre').size('100%', h_fenetre);   /// svg fond //  
  var polygon = svg_cadre.polygon('0,0 0,'+h_fenetre+' 0,'+h_fenetre+', 0,0').fill(color_svg_bord_gauche);
  $content.css({opacity:0, left:-500});

   

  // Init Isotope pour les rea //
     var $container = $('.grid').isotope({
      itemSelector: '.miniat',
       percentPosition: true,
       masonry: {
        columnWidth: '.grid-sizer',
        gutter: '.grid-gutter',
      }
    });

  //  $('.filter_all_rea').on( 'click', 'button', function() {
  //   var filterValue = $(this).attr('data-filter');
  //   $('.filter_all_rea button').removeClass('active_filter');
  //   $(this).addClass('active_filter');
  //   $container.isotope({ filter: filterValue });
  // });


  //  $container.on( 'arrangeComplete', onArrange_rea );

  function init_all(page_init){ // all_rea ou single_rea ou page
    
    if (!deja_init){
    ///// / INIT //////
  
  // INIT REA DROITE //
    if(affichage_desktop){
     TweenMax.fromTo($container_rea, 0.9, {css:{right:"-100%", opacity:0}},{css:{right:0, opacity:1},delay:0.4,ease:Power4.easeOut});
    }
  // INIT POLYGON   
     // haut gauche, bas gauche, bas milieu, haut milieu
    if(page_init != "all_rea" && affichage_desktop){ // si page init différentes de page all realisation
      polygon.animate(500,'>',0).plot([[0,0],[0,h_fenetre],[midle_width,h_fenetre],[midle_width,0]]).after(function(situation){
        $('body').bind('mousemove', ecoute_souris);
      });

    }
    
    if(page_init == "all_rea"){ 
      full_rea_liste = true;
    }

  
     // INIT CONTENT
     TweenMax.to($content, 0.9, {css:{left:0, opacity:1},delay:0.4,ease:Power4.easeOut});

    }


   add_scroll_bar();
 
  corps_content_rea = $("#right_rea .ss-content");

  deja_init = true;
  }
  // par defaut = accueil;




      //////////////////
/////// RESIZE PAGE ///////
  /////////////////////
  
    // fc pour resize le svg en fonction de la page (singel rea ou non et de la dernière position souris : diff_pourcen)
    function resize_polygone(){
		l_fenetre = $('#wraper_site').width();
    	h_fenetre = $(window).height();
      $right_rea.css('width', parseInt($container_rea.width()));  // resize block avec les reas par rapport au parent //
    	midle_width = parseInt(l_fenetre/2 + 60);
    	$('#SvgjsSvg1001').css('height',h_fenetre);
    	width_top = midle_width + diff_pourcen;
        width_bottom = midle_width - diff_pourcen;
        if(single_rea){
        	left_de_base = parseInt(l_fenetre/4);
        }else{
        	left_de_base = 0;
        }
        if(!full_rea_liste){
        	 // haut gauche, bas gauche, bas milieu, haut milieu
       			polygon.stop().plot([[0,0],[0,h_fenetre],[parseInt(width_bottom+left_de_base),h_fenetre],[parseInt(width_top+left_de_base),0]]);
        }else{
        	polygon.stop().plot([[0,0],[0,h_fenetre],[0,h_fenetre],[0,0]]);
        }   
    }

    $( window ).resize(function() {
       if(affichage_desktop){
    	 resize_polygone();
      }
	});

      //////////////////
/////// BIND ECOUTE SOURIS ///////
  /////////////////////


    //  fct bind or unbbind pour ecouter mouvement de la souris
     function ecoute_souris(event){
     	if(!full_rea_liste && affichage_desktop){
        	mouseUpdate(event.clientX);
    	}
    }

    // fc pour faire bouger $content vers la gauche, evoluer le svg et $right_content vers la droite seulement si pas single 
    function mouseUpdate(x){                

      // 100% = souris à gauche de la fenetre
      // 0% = souris à droite de la fenetre
       var pourcentage_x = 100 - Math.round((x/l_fenetre)*100);
    
       diff_pourcen = parseInt(pourcentage_x/1.2);

       width_top = midle_width + diff_pourcen;
       width_bottom = midle_width - diff_pourcen ;
        
        // haut gauche, bas gauche, bas milieu, haut milieu
       polygon.stop().plot([[0,0],[0,h_fenetre],[parseInt(width_bottom+left_de_base),h_fenetre],[parseInt(width_top+left_de_base),0]]);
 
  		// pour empecher le cadre svg de depasser sur la partie de droite (et de pouvoir cliquer), on change la width du cadre svg en fonction de la position de la souris.
  		// largeur change en fonction de simple page ou single realisation.
       minus_svg_cadre = parseInt((100-pourcentage_x)/11);
       percent = parseInt(GLOBAL_WIDTH_SVG_CADRE-minus_svg_cadre)+"%";
       $svg_cadre.css("width",percent);
      // TWEENMAX !! Plutôt que animate, c'est juste parfait.
       TweenMax.to($svg_cadre, 1.5, {css:{left:0+(diff_pourcen/1.5)},ease:Power4.easeOut});

       if(!single_rea){
         TweenMax.to($content, 1.5, {css:{left:parseInt(left_de_base+10+diff_pourcen)},ease:Power4.easeOut});
         TweenMax.to($right_rea, 1.5, {css:{right:parseInt(left_de_base+diff_pourcen)},ease:Power4.easeOut});
      }else{
          
      	 //$("#svg_cadre").css('width', parseInt(width_svg_single - minus_svg_cadre));
      }

   }

  //////////////////////////////////////////////////
    ////DIRECTIVE CHANGEMENT PAGE HASCHANGE ///////
  /////////////////////


	// hashchange //
	$(window).hashchange(function(){
   
		var arg = window.location.hash.substring(3);
		var link = $domaine+arg;
		// Special realisation
		var id_link = arg.substr(0,arg.length-1); if(id_link == '') id_link = 'accueil';

     is_404 = false;

     if (array_url_autorize.indexOf(arg) === -1) {
          // erreur 404 //
          // l'élément n'existe pas dans le tableau
          //console.log("Erreur 404");
           is_404 = true;
           LoadContentWrapper  = $domaine+'404-2/' + ' .pageloader-inner';
      }
    if(window.ga && ga.loaded){
      ga('send', 'pageview', arg);
    }
    if(arg != 'cf7-f59-p15-o1'){
  		if(arg.indexOf("realisations") == 0){ // on est sur toutes les realisations
        init_all("all_rea"); // Pour le rechargement d'une page de ce type
  			$('.mastnav li').removeClass('active');
  			$('.mastnav li#l_'+id_link).addClass('active');
        nb_go_col_droite = 'full';
  			loadAllReal_to_left(); 
        var title = 'Réalisations | Agence PM.VIAL';
        document.title = title; //on change le titre
  		}
  		else if(arg.indexOf("realisation/") == 0){ // on est sur une realisation particuliere
         init_all("single_rea"); // Pour le rechargement d'une page de ce type
  			$('.mastnav li').removeClass('active');
        nb_go_col_droite = 'one';
      
        active_this_realisation(arg,true);
          // si page précédente, pas single_rea alors on refait un scroll pour mettre en avant la miniuature du projet courant apres 1s pour avoir le temps de le remodeler..//
        if (!single_rea) setTimeout(function(){ active_this_realisation(arg,false); }, 1000);
  			loadContent_left(arg,link, 'single_rea');
  		}else{ // on est sur une page classique
        init_all("page"); // Pour le rechargement d'une page de ce type
        nb_go_col_droite = 'two';
  			loadContent_left(arg,link, 'page_left');
  		 $('.mastnav li').removeClass('active');
        $('.mastnav li#l_'+id_link).addClass('active');
  		}

      TweenMax.to($svg_cadre, 0.5, {css:{left:0},ease:Power4.easeOut});
      

    } // fin si form contact

	});

  // POUR LE CHARGEMENT DE PAGE LA PREMIERE FOIS
  // SI PAGE DIFFERENT QUE ACCUEIL (AGENCE)
	if(window.location.hash.substring(3)!=''){
		$(window).trigger('hashchange' );
	}


    //////////////////////////////////////////////////
    ////CANGEMENT DISPOSITION POUR TOUTES LES REAS ///////
  /////////////////////

	// on  a cliqué sur réalisations donc on ferme le polygon sur la gauche, 
	// on deploie sur la gauche la colonne avec toutes les réalisations
	function loadAllReal_to_left(){

     TweenMax.to($right_rea, 1.5, {css:{right:0},ease:Power4.easeOut}); // on rétablit le right à Zero.

		$('body').unbind('mousemove', ecoute_souris);

		// animation polygon sur la gauche
	    polygon.animate(400,'>',50).plot([[0,0],[0,h_fenetre],[0,h_fenetre],[0,0]]).after(function(situation){  
	    	$("#svg_cadre").css('width', "0%");
    		$("#left_pm").css('width', "0%"); 

	    });
	    var $old_content_to_move = $('#left_pm #inner_page');
    
      // PDOM : Si je mets ca dans le on_complete, ca peut poser des problemes si naviagation tres vite.. HERE OR NOT ?
       full_rea_liste = true;
       single_rea = false;
       

		  TweenMax.to($old_content_to_move, 0.4, {css:{opacity:0,left:-800},ease:Power4.easeOut,onComplete: function(){   
       precedent_nb_col_droite = 'full';
       gestion_taille_col_right('full');
		}});
		
 
	}

//////////////////////////////////////////////////
    ////FCT POUR CHANGEMENT LARGEUR CADRE SVG + LEFT PM EN FONCTION DE LA PAGE ///////
  /////////////////////

   function cadre_left_single(){
    $("#svg_cadre").css('width', width_svg_single+"%");
    $("#left_pm").css('width', width_left_single+"%");
    GLOBAL_WIDTH_SVG_CADRE = width_svg_single;
    //disparition_liste_rea_raccourcie();
   }

  function cadre_normal(){
     left_de_base = 0;
     $("#svg_cadre").css('width', width_svg_cadre+"%");
     $("#left_pm").css('width', width_left_normal+"%");
     GLOBAL_WIDTH_SVG_CADRE = width_svg_cadre;
     //disparition_liste_rea_agrandi();
  }


//////////////////////////////////////////////////
    //// GESTION TAILLE COL RIGHT + DISPOSITIO ISOTOPE POUR TOUTES LES PAGES SINGLE / ALL REAS / PAGE ////////
  /////////////////////

  
  // on passe par la fonction seulement si changement ds la zone de drotie (page -> single - single -> all rea etc..)
  function gestion_taille_col_right(nb_go_col_droite){
    // console.log('gestion_taille_colLLLL '+nb_go_col_droite);
      if (nb_go_col_droite == "one") // On va sur une realisation, une seule colonne de rea
      {
        largeur_percentage_container_rea = "30%";
        // $("#secon").css({right:"6.5%"});
        if(affichage_desktop) menu_second.style.right = null;


      }else if(nb_go_col_droite == "two"){  // On va sur une page, deux colonnes de rea
          largeur_percentage_container_rea = "50%";
           if(affichage_desktop) menu_second.style.right = null;
      }else if(nb_go_col_droite == "full"){
        largeur_percentage_container_rea = "100%";
         if(affichage_desktop) menu_second.style.right = ""+parseInt(l_fenetre-901)+"px";
           
         //$("#secon").css({right:parseInt(l_fenetre-901)});
      }

      // mobile + all realisations
      if(nb_go_col_droite == "full" && !affichage_desktop){
        TweenMax.fromTo($container_rea, 0.4, {right:"-100%"},{right:0,
          onComplete:function(){ 
            //console.log("scroller_hereeee PMPDOOM")
            $('html,body').animate({scrollTop:0}, 100, function(){
               $container.isotope();
            }); // on va scroller dans la partie rea;
          }
        });

      }else if(!affichage_desktop){
          // mobile autre
        TweenMax.to($container_rea, 0.5, {right:"-100%"});
      }
      

      $('body').removeClass('parent_one parent_two parent_full');
      $container_rea.removeClass('parent_one parent_two parent_full');
      $('body').addClass('parent_'+nb_go_col_droite);
      $container_rea.addClass('parent_'+nb_go_col_droite);

     
      if (affichage_desktop){ // seulement desktop
      TweenMax.to($container_rea, 0.4, {width:largeur_percentage_container_rea,onComplete:function(){ 
       $right_rea.removeClass('one two full');   // on enleve toute les classes sur #$right_rea;
       $right_rea.addClass(nb_go_col_droite); // on ajoute la classe correspondant à la nouvelle taille / one / two / full;
       $right_rea.css('width', parseInt($container_rea.width()));
       $container.isotope(); // on réordone la grille de l'isotope
       TweenMax.fromTo($right_rea, 1, {opacity:0},{opacity:1});
        precedent_nb_col_droite = nb_go_col_droite;
        corps_content_rea = $("#right_rea .ss-content");
        corps_content_rea.scrollTop(0); // init la scorllbar des reas a 0; PODOM ca marche pas, si ca marche mais pas encore isotope donc pb //
    }});
     }
  }
  // Desactivation du menu principale

  function onArrange_rea() {
     if ($active_rea.length){
      var pos = $active_rea.position();
      corps_content_rea.animate({scrollTop:pos.top}, 500, 'swing'); // on va scroller dans la partie rea;
    }
  }

  //////////////////////////////////////////////////
    //// ON CACHE LE CONTENU A GAUCHE DE LA PAGE ET ON MODIFIE POLYGON POUR QU'IL SE CACHE, 
    // Une fois fini seulemet, on passe la varialbe transition_left_finished à true pour finalement lancer le declanchement du load etc
  /////////////////////


  	// Only pour les pages internes sur la gauche
	 function pushLeft_content(){
	 	 var $old_content_to_move = $('#left_pm #inner_page');
		TweenMax.to($old_content_to_move, 0.4, {css:{opacity:0,left:-400},ease:Power4.easeOut});
		// deplacement + rapetissement polygon sur la gauche
	 	 polygon.stop().animate(400,'>',50).plot([[-100,0],[-100,h_fenetre],[-100,h_fenetre],[-100,0]]).after(function(situation) {
	 	 	transition_left_finished = true;
	 	 });
	 	// TweenMax.to($right_rea, 0.8, {css:{opacity:0,scale:0.7},ease:Power4.easeOut});
	 }


    //////////////////////////////////////////////////
    //// PAGE STATIQUE ET SINGLE : FCT DE LOAD AVEC ACTION FINALE (en attente de variable transition_left_finished)
  /////////////////////

	
	 // Chargement des contenus pour les pages "statiques" de gauche et les pages single realisation
   // arg = /sqd/, href = le link
	 function loadContent_left(arg,href, type_page) {

        //$('#loader').fadeIn(100);
        
        var LoadContentWrapper = href + ' .pageloader-inner'; // contenu de la page chargé //
       
		    $('body').unbind('mousemove', ecoute_souris); // descative le bind du mousemove

        // une fois contenu de gauche caché, on fait le load
        transition_left_finished = false;

        // Si la colonne de droite doit faire un changement (entre 1 col ou 2 col etc.., on le fait ici)
        if(nb_go_col_droite != precedent_nb_col_droite){
            gestion_taille_col_right(nb_go_col_droite);
        } 


        // Single réa comme page classique :
        // Si page precedente = page all réalisations, alors on a pas besoin de pousser le cadre à gacuhe, c'est déjà fait ! On lance directement le load
        if (full_rea_liste == true){ 
            $('#btn_all_rea_visible').trigger('click');
            $('#btn_all_rea_visible').addClass('active_filter');
            transition_left_finished = true;
        }else{
            pushLeft_content();
        } 
    	 
         if (is_404) {
           LoadContentWrapper  = $domaine+'404-2/' + ' .pageloader-inner';
        }
      
     
        $('#left_pm').delay(100).queue(function () {
        	$('#loader').fadeOut(100);


            $(this).load(LoadContentWrapper, function () {
            	
            	var title = $(this).find('.pageloader-inner').attr('data-title');
              var desc = $(this).find('.pageloader-inner').attr('data-extrait');
        
            	document.title = title; //on change le titre
              $('meta[name=description]').remove();
              $('head').append( '<meta name="description" content="'+desc+'">' );
            	
            	$(this).find('#inner_page').css({opacity:0, left:-500});

            	function insertNewPage() {
	            	// Ne pas inserer la précedente page tant que la disparition de la précédente n'est pas terminé
    					if (!transition_left_finished) {
    						return window.setTimeout(insertNewPage, 10);
    					}

              if (affichage_desktop){
  					   var el = document.querySelector('.move_on_change');
    					 SimpleScrollbar.initEl(el);
             }

             var $new_content_to_move = $('#left_pm #inner_page');
  					

             // CHANGEMENT DE CADRE //
             if(type_page == 'single_rea'){  // PAGE SINGLE REA
              if (single_rea == false) cadre_left_single(); // si on a deja gerer la gestion du cadre, pas la peine de le refaire
              single_rea = true;
              left_de_base = parseInt($(window).width()/4); // left de base
              ajout_width = left_de_base; // on ajoute 25% au 50 de base.
              
               // SI On a filtrer les réalisations, alors on remet le filtre à tous..
              if(filtre_projet != "*"){
                  $('.cs-options > ul > li:first-child').trigger('click');
                  $('.cs-select').removeClass('cs-active');
              }

            }else{ // PAGE CLASSIQUE
              // si page précédente = la page d'archive realsation ou page de single
             if (single_rea == true || full_rea_liste == true) cadre_normal();
              single_rea = false;
              // page a charger = page classique texte
              left_de_base = 0;
            
            }




  					 // novuelle page de type 
  					if(type_page == 'single_rea'){
			        	  // SI SINGLE REA
			        	  	   	  
      					  TweenMax.to($new_content_to_move, 1.5, {css:{opacity:1,left:0},ease:Power3.easeOut, delay:0.2});

			        	  polygon.stop().animate(500,'-',0).plot([[0,0],[0,h_fenetre],[width_bottom+ajout_width,h_fenetre],[width_top+ajout_width,0]]).after(function(situation){
      						  $('body').bind('mousemove', ecoute_souris);
                     $('#inner_page .ss-content').addClass('the_scroll');            
                        //  WOW EFFECT //
                      var wow = new WOW(
                        {
                          boxClass:     'wow',      // animated element css class (default is wow)
                          animateClass: 'animated', // animation css class (default is animated)
                          offset:       0,          // distance to the element when triggering the animation (default is 0)
                          mobile:       false,       // trigger animations on mobile devices (default is true)
                          live:         false,       // act on asynchronously loaded content (default is true)
                        //  callback:     afterReveal,
                          scrollContainer: '.the_scroll' // optional scroll container selector, otherwise use window
                        }
                      );
                     wow.init();

                    // WOW EFFECT //


      						});

			        }else{
			        // SI PAGE NORMAL //
			        
                   $('#inner_page .ss-content').addClass('the_scroll');            
                        //  WOW EFFECT //
                      var wow = new WOW(
                        {
                          boxClass:     'wow',      // animated element css class (default is wow)
                          animateClass: 'animated', // animation css class (default is animated)
                          offset:       0,          // distance to the element when triggering the animation (default is 0)
                          mobile:       false,       // trigger animations on mobile devices (default is true)
                          live:         false,       // act on asynchronously loaded content (default is true)
                        //  callback:     afterReveal,
                          scrollContainer: '.the_scroll' // optional scroll container selector, otherwise use window
                        }
                      );
                     wow.init();

			        // SI SIMPLE PAGE GAUCHE
					     polygon.stop().animate(500,'-',0).plot([[0,0],[0,h_fenetre],[width_bottom,h_fenetre],[width_top,0]]).after(function(situation){
      					$('body').bind('mousemove', ecoute_souris);
                 initContactForm(); 
      					owl_a_propos();
      				});
               TweenMax.to($new_content_to_move, 1.5, {css:{opacity:1,left:0},ease:Power3.easeOut, delay:0.2});

	
      				}
          if (!affichage_desktop){
            // scroll en haut de la page parce sinon on doit le faire manuellement sur chaque page
              $('html,body').animate({scrollTop:0}, 100); // on va scroller dans la partie rea;

          }

					full_rea_liste = false;
				}

				insertNewPage();	
         
              
             
           // file was found
           ////PODOM ICI END

            });
            $(this).clearQueue();
        });

        
     } // fin loadContent_left


function UrlExists(url, cb){
    jQuery.ajax({
        url:      url,
        dataType: 'text',
        type:     'GET',
        complete:  function(xhr){
            if(typeof cb === 'function')
               cb.apply(this, [xhr.status]);
        }
    });
}


// Pour debug wow.js
//      function afterReveal (el) {
//   el.addEventListener('animationend', function () {
//     console.log('This runs once finished!'+el);
//   });
// }


     //////////////////////////////////////////////////
    //// CLICK N'IMPORTE QUAND SUR UNE REALISATION
  /////////////////////
  var to_active_rea = '';
  var $active_rea = '';
  function active_this_realisation(hash, avec_isotope){
   
    //if(avec_isotope
    $container.isotope();

    to_active_rea = hash.substr(12);
    to_active_rea = to_active_rea.substr(0,to_active_rea.length-1);

       if ($active_rea) {
          $active_rea.removeClass('active_rea');
       }
    if(!is_404){
    if ($("#rea_"+to_active_rea).length) {
      $active_rea = $( "#rea_"+to_active_rea);
      $active_rea.addClass('active_rea');

      var pos = $active_rea.position();
      corps_content_rea.animate({scrollTop:pos.top}, 500, 'swing'); // on va scroller dans la partie rea;
    

    }
   }
  }
    // PODOM : Faire avec l'url qui change et pas au click. URL = ID miniat. mais attention ici duplicate ID
    //  $( ".miniat a" ).click(function() {
    //     var $miniat = $(this).parent().parent();
    //     $( ".miniat" ).removeClass('active_rea');
    //     $miniat.addClass('active_rea');

    //     var pos = $miniat.position();
    //     corps_content_rea.animate({scrollTop:pos.top}, 500, 'swing');

    //     // scroll du container pour avoir la réalisaiton en haut
    // });














    //////////////////////////////////////////////////
    //// OWL A PROPOS POUR LANCER LES DIAPORAMA.. EN ATTENTE..
  /////////////////////
     owl_a_propos();
     function owl_a_propos(){
		 var owl_produit = $("#slider_apropos");
			if ( $( owl_produit).length ) {
		 	 owl_produit.owlCarousel({
		  	 loop:true,
		  	 autoplaySpeed:500,
		  	 autoplay:true,
			   margin:0,
			   nav:false,
			   items:2,
			//change : callback
		  });
		}
		// function callback(event) {
	 //       $('.active .counter').counterUp({
	 //        delay: 2,
	 //        time: 1000
	 //      });
  // 		}

 //  	 owl_produit.on('change.owl.carousel', function(event) {
 //   		 var item      = parseInt(event.item.index);
 //   		 var page      = parseInt(event.item.index/2);
 //   		 go_counter(item+2);
	// });

  	// function go_counter(item){
  	// 	 $('#slider_apropos .owl-item').eq(item).find('.counter').counterUp({
	  //       delay: 2,
	  //       time: 1000
	  //     });
  	// }
  	
	} // fin owl_a_propos

  var filtre_projet = '*';
      [].slice.call( document.querySelectorAll( 'select.cs-select' ) ).forEach( function(el) {  
                new SelectFx(el,{onChange : function( val ) {

                    var str = "";
                    str =  $( "#select_filter option:selected" ).val();
                    
                    $container.isotope({ filter: str });
                    filtre_projet = str;
                }});
      } );


   
  

  // FORM CONTACT LABEL ///

   $( "body").on('click focus',".wpcf7-form input[type='text'],.wpcf7-form input[type='email'],.wpcf7-form textarea",function() {
      $(this).parent().parent().addClass('focus');
  });

   $( ".wpcf7-form input[type='email'],.wpcf7-form input[type='text'],.wpcf7-form textarea" ).each(function() {
      if($(this).val() != '') $( this ).parent().parent().addClass('focus');
  });



function initContactForm() {
       $( 'div.wpcf7 > form' ).each( function() {
        var $form = $( this );
        wpcf7.initForm( $form );
        if ( wpcf7.cached ) {
         wpcf7.refill( $form );
        }
       });
      }

  jQuery('.mastnav').hide();
  function apparition_elt_page(){
    jQuery('.mastnav').fadeIn(500);
    var arg_init = window.location.hash;
    
     // new //
     if (arg_init == ''){
      // en fonction de body.class ?
      var body_class = $('body').attr('class');
      if (body_class.search('home')  >= 0){
         //console.log('Accueil');
         window.location.hash = '#!/';
      }else if (body_class.search('error404') >= 0 || body_class.search('page') >= 0){
         //console.log('Erreur 404 ou page Expertise, Contact');
         init_all('page');
         gestion_taille_col_right('two');
      }else if (body_class.search('post-type-archive') >= 0){
        //console.log('page all réalisatons ');
        gestion_taille_col_right('one');
        init_all('page');
      }else if (body_class.search('single') >= 0){
        //console.log('réalisation particuliere ');
        gestion_taille_col_right('one');
        init_all('single_rea');
      }else{
          window.location.hash = '#!/';
      }
    }
   
    if (arg_init == '#!/' ) {init_all('page'); gestion_taille_col_right('two');}// init pour la page d'accueil //


    //ancien_modele
    //if (arg_init == "") window.location.hash = '#!/';
    //if (arg_init == '#!/' ) {init_all('page'); gestion_taille_col_right('two');}// init pour la page d'accueil //
  }

  var anim_loader_termine = false;
  function attente_loader_finish() {
    
    anim_loader_termine = true;
  }
  window.setTimeout(attente_loader_finish,2000);

  function loader_finish(){
    if (!anim_loader_termine) {
       return window.setTimeout(loader_finish, 100);
    }
    jQuery(".loader").fadeOut("1500",function() {
      apparition_elt_page();
    });
  }

  jQuery(window).load(function() {
    loader_finish();
  }) ;

});




